export default "__VITE_ASSET__DP0f_GyK__"